import {
  AttributeValueFragment,
  CheckoutFragment,
  ProductVariantFragment,
  SelectedAttributeFragment,
} from 'src/saleor_graphql/generated/graphql'

export const extractAttributesBySlug = (
  slug: string,
  attributes: SelectedAttributeFragment[],
): AttributeValueFragment[] => {
  return (
    attributes
      .find(attr => attr.attribute.slug === slug)
      ?.values.flatMap(val => val) ?? []
  )
}

export const withParsedAttributes = (variant: ProductVariantFragment) => {
  return {
    ...variant,
    parsedAttributes: {
      affiliateTrial: extractAttributesBySlug(
        'affiliate-trial',
        variant.attributes,
      ),
      description: extractAttributesBySlug(
        'description',
        variant.attributes,
      ).map(v => v.name)[0],
      premiumSubscriptionIds: extractAttributesBySlug(
        'premium-subscription-products',
        variant.attributes,
      ).map(val => val?.reference),
      suggestedAddon: extractAttributesBySlug(
        'suggested-addon',
        variant.attributes,
      )[0],
      suggestedAddonPromo: {
        code: extractAttributesBySlug(
          'suggested-addon-promo-code',
          variant.attributes,
        ).map(v => v.plainText)[0],
        content: extractAttributesBySlug(
          'suggested-addon-promo-copy',
          variant.attributes,
        ).map(v => v.plainText)[0],
        amount: extractAttributesBySlug(
          'suggested-addon-promo-value',
          variant.attributes,
        ).map(v => (v.name ? parseInt(v.name) : null))[0],
        forUserTypes: extractAttributesBySlug(
          'suggested-addon-promo-user',
          variant.attributes,
        ).map(v => v.name),
      },
    },
  }
}

export const parseCheckout = (checkout: CheckoutFragment) => {
  return {
    ...checkout,
    lines: checkout.lines.map(line => ({
      ...line,
      variant: withParsedAttributes(line.variant),
    })),
  }
}
